import React, { FC } from 'react';
import { PAGINATION_DIRECTION } from '../types';
import { localeStore } from 'src/mobx/localesStore';
import '../PaginationPageButton/style.scss';

interface IProps {
  direction: PAGINATION_DIRECTION;
  disabled: boolean;
  changePage: () => void;
}

const PaginationDirectionButton: FC<IProps> = ({ direction, disabled, changePage }: IProps): JSX.Element => {
  return (
    <button className="pagination__button" onClick={changePage} disabled={disabled}>
      {localeStore.t(direction)}
    </button>
  );
};

export default PaginationDirectionButton;
